import MuiTextField from "@mui/material/TextField";
import { styled } from "@mui/material";

/**
 * @description Styled TextField component for search input.
 * It supports expandable behavior and different sizes.
 */
export const StyledTextField = styled(MuiTextField, {
  shouldForwardProp: (prop) => prop !== "expandable" && prop !== "size" && prop !== "open",
})<{ expandable?: boolean; open?: boolean }>(({ theme, expandable, size, open }) => ({
  "&.MuiTextField-root": {
    flexShrink: 0,
  },
  // This mimics the default MUI TextField fullWidth behavior
  // Since we have a tooltip and the width is applied conditionally, we need to ensure it expands correctly
  ...(open && {
    width: "100%",
    "&.MuiTextField-root": {
      flexShrink: 1,
    },
  }),

  "& .MuiInputLabel-root": { display: "none" },

  // Root wrapper
  "& .MuiFilledInput-root": {
    borderRadius: "999px",
    border: `1px solid ${theme.palette.grey[40]}`,
    backgroundColor: theme.palette.grey[10],
    padding: "7px 12px", // Adjust padding to handle border and maintain consistent size
    color: theme.palette.grey[120],
    ...theme.typography.TextS,
    fontFamily: theme.typography.fontFamily,
    caretColor: theme.palette.secondary1[100],

    ...(expandable && {
      minWidth: "36px",
      width: "36px",
      cursor: "pointer",
    }),

    ...(size === "small" && {
      minWidth: "30px",
      width: "30px",
      padding: "6px 8px",
      ...theme.typography.TextXS,
    }),

    ...(open && {
      width: "100%",
    }),

    "&.Mui-focused, &:hover": {
      backgroundColor: theme.palette.grey[20],
      boxShadow: "none",
    },

    // Remove default underline
    "&:after, &:before": { borderBottom: "none" },
    "&:hover:not(.Mui-disabled):before": { borderBottom: "none" },
  },

  // HTML input inside
  "& .MuiInputBase-input": {
    padding: 0,
    margin: "0 4px",
    border: "none",
    color: theme.palette.primary.main,
    transition: "unset",
    height: "20px",

    ...(size === "small" && {
      height: "16px",
    }),

    "&::placeholder": {
      opacity: 1,
      color: theme.palette.grey[100],
    },
  },
}));
